import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from '@mui/material';
import * as React from 'react';
import { unstable_useBlocker as useBlocker } from 'react-router-dom';

export function NavigationGuard({ when }: { when: boolean }) {
    // Only block real page leaves. Same-path navigations (e.g. search-param updates such as
    // the vault album `?album=` sync) must pass through without prompting.
    const blocker = useBlocker(
        ({ currentLocation, nextLocation }) => when && currentLocation.pathname !== nextLocation.pathname,
    ); // { state: 'unblocked' | 'blocked' | 'proceeding', proceed?, reset? }
    const [open, setOpen] = React.useState(false);

    // Open dialog when navigation is blocked
    React.useEffect(() => {
        if (blocker.state === 'blocked') setOpen(true);
        if (!when) setOpen(false); // close if guard turns off
    }, [blocker.state, when]);

    const onStay = () => {
        setOpen(false);
        if (blocker.state === 'blocked' || blocker.state === 'proceeding') {
            blocker.reset?.(); // safe call only when meaningful
        }
    };

    const onLeave = () => {
        setOpen(false);
        if (blocker.state === 'blocked') {
            blocker.proceed?.(); // safe call only when meaningful
        }
    };

    return (
        <Dialog open={open} onClose={onStay}>
            <DialogTitle>Discard unsaved changes?</DialogTitle>
            <DialogContent dividers>
                <Typography variant="body2">You have unsaved changes. If you leave this page, they will be lost.</Typography>
            </DialogContent>
            <DialogActions>
                <Button onClick={onStay}>Stay</Button>
                <Button color="error" variant="contained" onClick={onLeave}>
                    Leave page
                </Button>
            </DialogActions>
        </Dialog>
    );
}
